import { CurrencyPipe } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'unity-gridcell-currency-shared',
  imports: [CurrencyPipe],
  templateUrl: './gridcell-currency-shared.component.html',
  styleUrl: './gridcell-currency-shared.component.scss',
})
export class GridcellCurrencySharedComponent {
  public readonly $value = input.required<number>({ alias: 'value' });
}
